import { atom, useAtom } from "jotai";
import { atomWithReset, useResetAtom } from "jotai/utils";
import { appraiseTips } from "@Api";
import { IBrandDataSource, IkindList, IModalList, AutoCarData } from "../types";

const { getNewCarBrands, getNewCarKinds, getNewCarModalYears } = appraiseTips;

// 厂牌相关数据
const initBrandData: IBrandDataSource = {
  index: [],
  data: [],
};

const brandsAtom = atom<typeof initBrandData>(initBrandData);

export const getBrandsAtom = atom(
  (_get) => _get(brandsAtom),
  async (_get, _set, params?: any) => {
    const res = await getNewCarBrands(params);

    if (res) {
      _set(brandsAtom, { ...initBrandData, 
        index: res.data.list.map((item) => item.label),
        data: res.data.list
      });
    }
  },
);

// 车款相关数据
const initKindData: IkindList[] = [];

const kindsAtom = atom<typeof initKindData>(initKindData);

export const getKindsAtom = atom(
  (_get) => _get(kindsAtom),
  async (_get, _set, params) => {
    const res = await getNewCarKinds(params);

    if (res) {
      console.log(res);
      _set(kindsAtom, [...initKindData, ...res.data.list]);
    }
  },
);

// 车型相关数据
const initModalData: IModalList[] = [];

const modalAtom = atom<typeof initModalData>(initModalData);

export const getModalsAtom = atom(
  (_get) => _get(modalAtom),
  async (_get, _set, params) => {
    const res = await getNewCarModalYears(params);

    if (res) {
      _set(modalAtom, [...initModalData, ...res.data.list]);
    }
  },
);
